<div class="not-found text-center">
    <img src="assets/img/not-found.gif" class="mb-25" alt="not-found">
    <h4 class="mb-15">A página que procura não existe!</h4>
    <p class="ms-auto me-auto">A página que você procura pode ter sido removida, teve seu nome alterado ou está temporariamente indisponível.</p>
    <a mat-raised-button class="atendimento mt-8" routerLink="/">Voltar</a>
</div>